import React, { useEffect, useRef, useState } from 'react';
import T from 'prop-types';

import Tooltip from './Tooltip';

const TruncatedText = ({ children, style, className, as = 'p', colorVariant }) => {
  const TagName = as;

  const containerRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const { width } = containerRef.current.getBoundingClientRect();
      setShowTooltip(containerRef.current.scrollWidth > Math.round(width));
    });

    resizeObserver.observe(containerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <Tooltip content={showTooltip ? children : null} colorVariant={colorVariant}>
      <TagName ref={containerRef} style={style} className={className}>
        {children}
      </TagName>
    </Tooltip>
  );
};

TruncatedText.propTypes = {
  children: T.node.isRequired,
  style: T.object,
  className: T.string,
  as: T.string,
  colorVariant: T.string,
};

export default TruncatedText;
